import { Music, Users, MapPin, Search, Calendar, Flame } from 'lucide-react';
import SEOLandingPage from '../../components/seo/SEOLandingPage';

export default function BandFindenBern() {
  return (
    <SEOLandingPage
      title="Band finden in Bern | jamnation - Berner Bands entdecken"
      description="Entdecke die besten Bands aus Bern und Region. Live-Bands für Events, Konzerte und Locations. Rock, Pop, Punk, Jazz und mehr aus der Hauptstadt."
      h1="Band finden in Bern"
      heroText="Tauche ein in die lebendige Berner Musikszene. Entdecke lokale Bands für dein Event, deine Location oder einfach zum Geniessen von Live-Musik in der Hauptstadt."
      keywords={[
        'band finden bern',
        'band suchen bern',
        'berner bands',
        'liveband bern',
        'coverband bern',
        'partyband bern',
        'band buchen bern',
        'musikszene bern',
      ]}
      locationName="Bern & Region"
      ctaButtons={[
        {
          text: 'Berner Bands entdecken',
          link: '/bands',
          primary: true,
        },
        {
          text: 'Band buchen',
          link: '/book-band',
        },
      ]}
      features={[
        {
          icon: MapPin,
          title: 'Lokale Bands',
          description:
            'Bands aus Bern, Köniz, Ostermundigen und der ganzen Region. Unterstütze die lokale Musikszene und finde Bands aus deiner Nähe.',
          link: '/bands',
        },
        {
          icon: Flame,
          title: 'Legendäre Szene',
          description:
            'Von der Reitschule bis zum ISC – Bern hat eine legendäre Underground-Szene. Entdecke Punk, Rock, Alternative und mehr.',
          link: '/bands',
        },
        {
          icon: Music,
          title: 'Vielfältige Genres',
          description:
            'Rock, Punk, Metal, Pop, Jazz, Reggae, Hip-Hop – die Berner Szene ist bunt und vielfältig. Finde deine Lieblingsband.',
          link: '/bands',
        },
        {
          icon: Calendar,
          title: 'Berner Live-Events',
          description:
            'Sieh dir an, wo Berner Bands auftreten. Von Bierhübeli bis Marians Jazzroom – verpasse keine Show mehr.',
          link: '/agenda',
        },
        {
          icon: Search,
          title: 'Gezielte Suche',
          description:
            'Filtere nach Genre, Bandgrösse und Verfügbarkeit. Finde schnell die perfekte Band für dein Event in Bern.',
          link: '/bands',
        },
        {
          icon: Users,
          title: 'Direkte Kontaktaufnahme',
          description:
            'Kontaktiere Bands direkt über ihr Profil. Kein Umweg über Agenturen – direkt mit den Musikern sprechen.',
          link: '/bands',
        },
      ]}
      teaserSection={{
        title: 'Was du auf jamnation alles tun kannst',
        description:
          'jamnation ist die Plattform für die gesamte Berner Musikszene. Entdecke Bands, veröffentliche Events und vernetze dich mit Musikern.',
        items: [
          'Durchsuche alle Bands aus Bern und höre dir Soundbeispiele an',
          'Sieh dir kommende Konzerte in Bern und Umgebung an',
          'Buche Bands direkt für dein Event ohne Agentur-Provision',
          'Erstelle ein Profil für deine Band und werde gefunden',
          'Teile Geschichten und Erlebnisse aus dem Bandalltag',
          'Vernetze dich mit der ganzen Berner Musikcommunity',
        ],
      }}
      seoTeaser={{
        title: 'Berns pulsierende Musikszene entdecken',
        description:
          'Bern ist mehr als die Hauptstadt – sie ist ein Hotspot für Live-Musik aller Genres. Von legendären Punk-Shows in der Reitschule über Jazz-Abende im Marians Jazzroom bis zu rockigen Nächten im Bierhübeli: Die Berner Musikszene ist vielfältig und lebendig. Auf jamnation findest du alle Bands der Region, kannst dir Soundbeispiele anhören und direkt Kontakt aufnehmen. Ob du eine Coverband für deine Hochzeit suchst, eine Rockband für dein Firmenevent buchen möchtest oder einfach neue lokale Musik entdecken willst – hier wirst du fündig. Unterstütze lokale Musiker, besuche ihre Konzerte und werde Teil der aktivsten Musikcommunity Berns.',
      }}
      faqItems={[
        {
          question: 'Welche Art von Bands finde ich in Bern?',
          answer:
            'Bern hat eine sehr vielfältige Szene: Von Rock- und Punk-Bands über Jazz-Ensembles bis zu Cover-Bands für Events. Die Stadt ist besonders bekannt für ihre Alternative- und Underground-Szene.',
        },
        {
          question: 'Kann ich Bands für private Events in Bern buchen?',
          answer:
            'Ja! Viele Berner Bands spielen bei Hochzeiten, Geburtstagen, Firmenevents und privaten Feiern. Kontaktiere sie direkt für eine Anfrage.',
        },
        {
          question: 'Wo treten Berner Bands normalerweise auf?',
          answer:
            'Beliebte Locations sind die Reitschule, ISC, Bierhübeli, Marians Jazzroom, Dachstock und viele mehr. Auf jamnation siehst du alle kommenden Konzerte.',
        },
        {
          question: 'Gibt es auch Jazz-Bands in Bern?',
          answer:
            'Absolut! Bern hat eine starke Jazz-Szene mit vielen talentierten Ensembles. Filtere einfach nach dem Genre "Jazz" in der Bandsuche.',
        },
        {
          question: 'Wie kann ich als Berner Band gefunden werden?',
          answer:
            'Erstelle kostenlos ein Bandprofil, füge Bern als Standort hinzu und lade Soundbeispiele sowie Fotos hoch. So können dich Veranstalter und Fans finden.',
        },
      ]}
    />
  );
}
